module.exports = __webpack_public_path__ + "static/media/ryanair.adba9e1d.svg";